export default __webpack_public_path__ + "static/media/filterIcon.d2d8ff00.svg";